import React, { useContext, useEffect, useState } from 'react';
import * as S from './styled';
import { useSnackbar } from 'notistack';
import Form from '../../..';
import {
  defaultBlurLogisticOriginForm,
  defaultLogisticOriginForm,
} from '../../../../../store/invoice/utils';
import { ExportContext } from '../../../../../provider/ExportProvider';
import { maskFieldDate, unmaskFieldDate } from '../../utils';

export default function FormLogisticOriginCreate() {
  const {
    getInvoice,
    setInvoice,
    createLogisticOrigin,
    setModal,
    getFormMessage,
    validateForm,
    filterSelectCompanies,
    selectCompanies,
    setCompanyFilterField,
    filterLogisticOrigin,
    groups,
    logisticGroupItems,
    logisticGroups,
    selectedGroupId,
  } = useContext(ExportContext)!.controllers.logistic;
  const { enqueueSnackbar } = useSnackbar();

  const getForm = <T extends FlattenKeys<LogisticOriginForm>>(field: T) =>
    getInvoice(`forms.logisticOrigins.create.${field}`);

  const setForm = <
    T extends FlattenKeys<LogisticOriginForm>,
    V extends DeepType<InvoiceState, `forms.logisticOrigins.create.${T}`>,
  >(
    field: T,
    value: V,
  ) => setInvoice(`forms.logisticOrigins.create.${field}`, value);

  const blurField = (field: keyof LogisticOriginForm) => () => {
    setInvoice(`blur.logisticOrigins.create.${field}`, true);
  };

  const logisticGroup = groups.logistic[0];

  const clearForm = () => {
    setInvoice(`forms.logisticOrigins.create`, {
      ...defaultLogisticOriginForm(),
      group: {
        id: logisticGroup?.id ?? 0,
        number: logisticGroup?.number ?? 0,
        name: logisticGroup?.name ?? ''
      },
    });
    setInvoice(`blur.logisticOrigins.create`, defaultBlurLogisticOriginForm());
  };

  const messages = getFormMessage('logisticOrigins.create');

  const [loading, setLoading] = React.useState(false);
  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    validateForm('logisticOrigins.create')
      .then(() => {
        setLoading(true);
        createLogisticOrigin()
          .then((logisticOrigin) => {
            enqueueSnackbar('Logística criada com sucesso', {
              variant: 'success',
            });
            clearForm();
            setModal('single.createLogisticOrigin', false);
            setInvoice('filters.logisticOrigins.data.data', [
              ...getInvoice('filters.logisticOrigins.data.data'),
              logisticOrigin,
            ]);
            filterLogisticOrigin();
          })
          .catch(() => {
            enqueueSnackbar('Houve uma falha ao criar a logística', {
              variant: 'error',
            });
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch(() => {
        console.log({ messages })
        enqueueSnackbar('Verifique a validade dos campos', {
          variant: 'error',
        });
      });
  };

  const [companyLoading, setCompanyLoading] = useState(false);
  const filterCompanies = () => {
    setCompanyLoading(true);
    filterSelectCompanies().finally(() => {
      setCompanyLoading(false);
    });
  };

  const group = getForm('group')

  useEffect(() => {
    const logisticGroup = logisticGroups[0];
    if (!selectedGroupId && (!group.id || !logisticGroups.some(({ id }) => id == group.id)))
      setForm('group', {
        id: logisticGroup?.id ?? 0,
        number: logisticGroup?.number ?? 0,
        name: logisticGroup?.name ?? ''
      });
  }, [logisticGroups, selectedGroupId]);

  return (
    <S.Form
      style={{
        maxHeight: '80vh',
      }}
      onSubmit={onSubmit}
    >
      <S.Body>
        <S.Grid>
          <Form.Input.Dropdown
            label="Companhia"
            items={selectCompanies.map(({ id, name }) => ({ id, name }))}
            value={getForm('company.name')}
            onChange={(e) => {
              setForm('company.name', e.target.value);
              setCompanyFilterField('name')(e);
            }}
            onDebouncedChange={filterCompanies}
            error={messages.company}
            onBlur={blurField('company')}
            hasClearItem
            onFocus={() => {
              setCompanyFilterField('name')({ target: { value: '' } });
            }}
            onSelected={({ id, name }) => {
              setForm('company', +id ? { id: +id, name: `${name}` } : { id: 0, name: '' });
            }}
            loading={companyLoading}
          // disabled={ability?.cannot('update', 'Invoice', 'company')}
          />
          <Form.Input.DatePicker
            label="Data Lançamento"
            value={maskFieldDate(getForm('releaseDate'))}
            onChange={(e) => setForm('releaseDate', unmaskFieldDate(e.target.value))}
            error={messages.releaseDate}
            onBlur={blurField('releaseDate')}
          />
          <Form.Input
            label="Nota Origem"
            value={getForm('originInvoiceNumber')}
            onChange={(e) => setForm('originInvoiceNumber', e.target.value)}
            error={messages.originInvoiceNumber}
            onBlur={blurField('originInvoiceNumber')}
          />
          <Form.Input
            label="Quantidade Volume"
            value={getForm('quantityVolume')}
            onChange={(e) => setForm('quantityVolume', +e.target.value || 0)}
            error={messages.quantityVolume}
            onBlur={blurField('quantityVolume')}
          />
          {!selectedGroupId && (logisticGroupItems.length > 1) ? (
            <Form.Input.Dropdown
              label="Grupo"
              items={logisticGroupItems}
              value={
                logisticGroupItems.find(({ id }) => id === getForm('group')?.id)?.name ??
                ''
              }
              error={messages.group}
              onBlur={blurField('group')}
              onSelected={(item) => {
                setForm('group', item.data);
              }}
              disabled={logisticGroupItems.length === 1}
            />
          ) : null}
        </S.Grid>
      </S.Body>
      <S.Actions>
        <Form.Button type="button" onClick={clearForm}>
          Limpar
        </Form.Button>
        <Form.Button loading={loading}>Criar</Form.Button>
      </S.Actions>
    </S.Form>
  );
}
